import useSWR from 'swr';

export interface SCIMSettings {
  enabled: boolean;
  has_token: boolean;
  endpoint: string;
  last_sync_at?: string;
  last_sync_op: string;
  updated_at?: string;
  updated_by: string;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => r.json());

export function useSCIMSettings() {
  return useSWR<SCIMSettings>('/api/admin/scim', fetcher, { refreshInterval: 30_000 });
}

export async function setSCIMEnabled(enabled: boolean): Promise<void> {
  const res = await fetch('/api/admin/scim', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ enabled }),
  });
  if (!res.ok && res.status !== 204) throw new Error(`set failed: ${res.status}`);
}

export async function regenerateSCIMToken(): Promise<{ token: string; note: string }> {
  const res = await fetch('/api/admin/scim/regenerate', {
    method: 'POST',
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
